import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Grid, Segment } from 'semantic-ui-react'
import { Divider } from 'semantic-ui-react'

const RecentActions = () => {
    const [actions, setactions] = useState([])
    const [allActions, setAllActions] = useState([])
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    useEffect(() => {
        getAllActions()
    }, [])

    const getAllActions = async () => {
        console.log("callingbacked")
        console.log(baseURL)
        let temp = await axios.get(baseURL + '/getAllActions', {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })
        setactions(temp.data)
    }
    const listActions = (
        <React.Fragment>
            <Grid columns={3} divided='vertically' style={{ marginLeft: 0, marginRight: 0 }}>
                {actions.map((action) => (
                    <Grid.Row textAlign={'left'} style={{ fontStyle: 'SFProText-Regular', fontSize: '14px', fontWeight: '500', paddingTop: '0', paddingBottom: '0' }}>
                        <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                            {action.task}
                        </Grid.Column>
                        <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                            {action.firstName} {action.lastName}
                        </Grid.Column>
                        <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                            {(new Date(action.created_at)).toLocaleString()}
                        </Grid.Column>
                    </Grid.Row>
                ))}
            </Grid>
        </React.Fragment>
    )

    return (
        <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>

            <div style={{paddingRight: '20px', paddingLeft: '20px', }}>
                <span style={{ fontStyle: 'SFProText-Bold', fontSize: 20, color: 'rgba(37, 39, 51, 1)', fontWeight: 'bold'}}>Recent Activities</span>
                <span style={{ fontStyle: 'SFProText-Bold', fontSize: 14, color: 'rgba(55, 81, 255, 1)', float: 'right' }}>View Details</span>
            </div>

            <Grid columns={3} divided='vertically' style={{ fontStyle: 'SFProText-Bold', fontSize: '14px', fontWeight: '500', color: '#9fa2b4', paddingTop: '10px', margin: '0' }}>
                <Grid.Row textAlign={'left'} style={{ paddingTop: '0', paddingBottom: '0' }} >
                    <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                        <p>Task</p>
                    </Grid.Column>
                    <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                        <p>Customer Name</p>
                    </Grid.Column>
                    <Grid.Column style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                        <p>Date</p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            {actions.length === 0 ? null : listActions}
        </div>
    )
}
export default RecentActions